<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px">
    <v-card :color="color" dark>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <v-container>
          <form action>
            <v-row>
              <v-col v-if="this.index > -1" cols="12" xs="6" sm="12">
                <v-file-input
                  v-model="file"
                  label="Imagen"
                  show-size
                  :color="icon_color"
                  accept="image/*"
                  data-vv-name="image"
                  prepend-icon="mdi-camera"
                  v-validate="'size:2000'"
                  :error-messages="errors.collect('image')"
                  hint="obligatorio"
                  persistent-hint
                ></v-file-input>
              </v-col>
              <v-col cols="12" xs="6" sm="12" v-else>
                <v-file-input
                  v-model="file"
                  label="Imagen"
                  show-size
                  accept="image/*"
                  data-vv-name="image"
                  prepend-icon="mdi-camera"
                  :color="icon_color"
                  v-validate="'required|size:2000'"
                  :error-messages="errors.collect('image')"
                  hint="obligatorio"
                  persistent-hint
                ></v-file-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" xs="6" sm="12">
                <v-text-field
                  v-model="item.name"
                  :color="icon_color"
                  label="Nombre"
                  data-vv-name="word_name"
                  v-validate="'required|max:30'"
                  :maxlength="max"
                  :error-messages="errors.collect('word_name')"
                  hint="obligatorio"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" xs="6" sm="12">
                <v-select
                  v-model="item.word_type"
                  :items="options"
                  label="Tipo de palabra"
                  item-text="label"
                  item-value="value"
                  data-vv-name="word_type"
                  v-validate="'required'"
                  :error-messages="errors.collect('word_type')"
                  hint="obligatorio"
                  persistent-hint
                ></v-select>
              </v-col>
              <v-col cols="12" xs="6" sm="12">
                <span class="text-left mb-0 blue--text">{{ information }}</span>
              </v-col>
            </v-row>
          </form>
        </v-container>
      </v-card-text>
      <v-divider class="mx-4"></v-divider>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn :color="link" text @click="save">Guardar</v-btn>
        <v-btn :color="link" text @click="close">Cancelar</v-btn>
        <p style="visibility: hidden; font-size: 0.01px">
          {{ reloadValidador }}
        </p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    index: Number,
    item: Object,
    value: Boolean,
  },
  computed: {
    ...mapState({
      color: (state) => state.layout.color,
      link: (state) => state.layout.link,
      icon_color: (state) => state.layout.icon_color,
      word: (state) => state.vocabulary.word,
    }),
    reloadValidador() {
      if (this.index === -1) this.$validator.reset()
      return this.item.name[0]
    },
    formTitle() {
      return this.index === -1 ? 'Nueva Palabra' : 'Editar Palabra'
    },
  },
  created() {
    this.$store.dispatch(
      'vocabulary/fetchVocabulary',
      this.$route.params.history_id
    )
  },
  data() {
    return {
      file: [],
      max: 30,
      information:
        '* El tamaño de la imagen debe ser menor a 2MB, y con dimensión de 650px X 325px',
      options: ['Peligro', 'Insumo', 'Herramienta', 'Alimento'],
      fileRules: [
        (value) =>
          !value || value.size < 2000000 || 'La imagen debe ser menor de 2 MB!',
      ],
      dialog: false,
      dictionary: {
        custom: {
          word_name: {
            required: () => 'El nombre de la palabra no puede ser vacío',
            max: () =>
              'El nombre de la palabra debe ser máximo de 30 caracteres',
          },
          word_type: {
            required: () => 'Selecionar tipo de palabra',
          },
          image: {
            required: () => 'La imagen no puede ser vacía',
            size: () => 'El tamaño de la imagen debe ser menor a 2MB',
          },
        },
      },
    }
  },
  mounted() {
    this.$validator.localize('es', this.dictionary)
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    close() {
      this.file = []
      this.item.name = ''
      this.item.word_type = []
      this.$validator.reset()
      this.$emit('input', false)
    },
    async save() {
      let isValidForm = await this.$validator.validateAll()
      if (isValidForm) {
        if (this.index > -1) {
          let word = {
            id: this.item.id,
            name: this.item.name,
            image: this.item.image,
            word_type: this.item.word_type,
          }
          await this.$store.dispatch('vocabulary/updateVocabulary', word)
          if (this.file != '') {
            //Upload Image
            let formData = new FormData()
            formData.append('file', this.file)
            try {
              await this.$store.dispatch('vocabulary/createImage', {
                id: this.item.id,
                history_id: this.$route.params.history_id,
                formData: formData,
              })
            } catch (err) {
              // eslint-disable-next-line
              console.log(err)
            }
          }
        } else {
          let word = {
            name: this.item.name,
            word_type: this.item.word_type,
          }
          await this.$store.dispatch('vocabulary/createVocabulary', {
            id: this.$route.params.history_id,
            item: word,
          })
          if (this.file != '') {
            //Upload Image
            let formData = new FormData()
            formData.append('file', this.file)
            try {
              await this.$store.dispatch('vocabulary/createImage', {
                id: this.word.insertId,
                history_id: this.$route.params.history_id,
                formData: formData,
              })
            } catch (err) {
              // eslint-disable-next-line
              console.log(err)
            }
          }
        }
        this.$validator.reset()
        this.close()
      }
    },
  },
}
</script>
<style scoped>
</style>